module.exports = __webpack_public_path__ + "img/tick.4bd8a613.svg";